<template>
  <div class="admin-layout">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'AdminLayout'
}
</script>

<style scoped>
.admin-layout {
  padding: 2px;
}
</style> 